import axios      from 'axios';
import { Config } from './configActions';

export const NOTIFICACAO          = 'NOTIFICACAO';
export const STATUS_NOTIFICACAO   = 'STATUS_NOTIFICACAO';
export const STATUS_TALENTOS      = 'STATUS_TALENTOS';
export const STATUS_ACESSO_DIARIO = 'STATUS_ACESSO_DIARIO';
export const TESTE_NOTIFICACAO    = 'TESTE_NOTIFICACAO';
export const TESTE_NOTIFICACAO2   = 'TESTE_NOTIFICACAO2';
export const SET_ERROR_ACTION     = 'SET_ERROR_ACTION';

var Authorization = {'Authorization': 'Bearer '+localStorage.getItem("jwtToken")}
Config();



export function GetListNotificacao(use_id,cur_id){
        
    const request = axios.get(`/api/notificacoes/listar/${use_id}/${cur_id}`,Authorization);
    return{
        type    : NOTIFICACAO,
        payload : request
    };    
}

export function SetStatusNotificacao(not_id){
   
    return{
        type    : STATUS_NOTIFICACAO,
        payload : not_id
    };  

}

export function SetStatusTalentos(){
     const talento = {
                        "not_id"          : "talentos",
                        "not_texto"       : "Desbloqueie um novo talento no painel de condecorações.",
                        "not_exibir"      : 1,
                        "not_tip_id"      : 2,
                        "not_tip_nome"    : "Talentos"
                      
                    }
    return{
        type    : STATUS_TALENTOS,
        payload : talento
    };  
}

export function SetStatusAcessoDiario(){
    const acessoDiario = { "not_id": 'bonusDiario',
                           "not_texto": "+10 XP Você está mais perto de se aproximar do futuro que você deseja. Entre pelo menos uma vez por dia e continue aprimorando sua experiência.",
                           "not_exibir": 1,
                           "not_tip_id": 6,
                           "not_tip_nome": "Bônus diário!"
                          }
    return{
        type    : STATUS_ACESSO_DIARIO,
        payload : acessoDiario
    };  
}

export function  GetTipoMenuNotificacao(tipo,acao){
	return dispatch =>{
        
                switch (tipo) {
                    case 1:
                        return acao.batalha.home;
                    break;
        
                    case 2:
                      return acao.condecoracoes.home;
                    break;
        
                    case 3:
                      return acao.condecoracoes.home;
                    break;
        
                    case 4:
                      return acao.batalha.home; 
                    break;
        
                    case 5:
                       return acao.batalha.home;  
                    break;
        
                    case 6:
                      return acao.pontuacao;
                    break;
                
                    default:
                    break;
                }
            }         
}


export function SetError(acao){


    return dispatch =>{

       
   switch(acao) {

       // case 400:
           
       // 	alert('Login ou senha está incorreta.');
       // 	dispatch(logout());

       // break;

       case 401:
           
           alert('A sua sessão foi experida, favor faça o login novamente');
           window.location.assign(`${Config().raiz}/home`);
          // dispatch(logout());

       break;

       case 500:
           
        alert('Erro interno do servidor');

   // 	 const request = 'Erro interno do servidor';
   // 	 return {
   // 		type: SET_ERROR_ACTION,
   // 		payload : request
   // }


       // window.location.assign(`${Config().raiz}/home`);
           
       break;

       default:
        
       //dispatch(logout());
       break;
       
   }

}
}



// WEBPACK FOOTER //
// ./src/actions/notificacaoAction.js